function ResolutionCtrl(ResolutionOptionService,$scope, $auth, $state, $location, $stateParams, AppSettings, AdminService, toaster, $rootScope, CommonService) {
  'ngInject';

  const vm = this;
  vm.resolutions = [];
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.name = !$stateParams.name ? '' : $stateParams.name;
  vm.loading = false;
  vm.resolutionloading = false;
  vm.addUserForm = {};
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.responseReceived = false;

  vm.init = function () {
    $rootScope.organizationNameView = false;
    vm.url = `/resolution_options.json?page=${vm.pageNumber}&size=${vm.size}&by_name=${vm.name}&sort=${vm.sortBy}`;
    vm.loading = true;
    ResolutionOptionService.listResolution(vm.url, function (response) {
      vm.loading = false;
      if (response.status == 200) {
        vm.resolutionResponse = response.data;
        vm.currentPage = !vm.resolutionResponse.pagination ? 1 : vm.resolutionResponse.pagination.current_page;
        vm.totalPages = !vm.resolutionResponse.pagination ? 1 : vm.resolutionResponse.pagination.total_pages;
        vm.resolutions = response.data.resolution_options;
      }
    });
  };

  vm.search = function (name) {
    $state.go('user.admin.resolutionOptions', {name: name , pageNumber: 1});
  };

  vm.paginate = function (param) {
    vm.url = vm.resolutionResponse.links[param];
    if(vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.admin.resolutionOptions', {pageNumber: vm.pageNumber, size: vm.size});
    }
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.admin.resolutionOptions', {sortBy: param});
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.resolutionResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.admin.resolutionOptions', {pageNumber: vm.pageNumber, size: vm.size});
  };

  vm.saveResolution = function () {
    vm.responseReceived = false;
    vm.submitted = true;
    vm.resolutionloading = true;
    if (vm.addUserForm.id) {
      ResolutionOptionService.updateResolution(vm.addUserForm, function (response) {
        vm.resolutionloading = false;
        if (response.status >= 200 && response.status < 300) {
          vm.resolutions[vm.resolutions.map(function (a) { return a.id }).indexOf(response.data.data.id)] = response.data.data;
          toaster.pop('info', 'Resolution information updated.');
          vm.editFlag = false;
          vm.addUserForm = {};
          $scope.userForm.$setPristine();
          $scope.userForm.$setUntouched();
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });

    } else {
      ResolutionOptionService.newResolution(vm.addUserForm, function (response) {
        if (response.status >= 200 && response.status < 300) {
          vm.resolutionloading = false;
          toaster.pop('info', 'New resolution added successfully');
          vm.init();
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
        vm.responseReceived = true;
        vm.addUserForm = {};
        $scope.userForm.$setPristine();
        $scope.userForm.$setUntouched();
      });
    }
  };

  vm.editResolution = function (resolution) {
    vm.editFlag = true;
    $('html,body').animate({
      scrollTop: $('#user_form').offset().top - 100
    },
      'slow');
    vm.addUserForm = JSON.parse(JSON.stringify(resolution));
  };

  vm.removeResolution = function(option_id){
    for(var i = vm.resolutions.length - 1; i >= 0; i--){
      if(vm.resolutions[i].id == option_id){
        vm.init();
      }
    }
    toaster.pop('info', 'Resolution deleted');
  };

  vm.deleteResolution = function (option_id) {
    if (option_id) {
      swal({
        title: 'Are you sure?',
        text: 'Do you want to delete this resolution option?',
        icon: 'warning',
        dangerMode: true,
        buttons: [true, true],
      })
        .then(willDelete => {
          if (willDelete) {
            ResolutionOptionService.deleteResolution(option_id, function (data) {
              if (data.status == 200) {
                vm.removeResolution(option_id);
              }
            });
          }
        });
    }
  };
}

export default {
  name: 'ResolutionCtrl',
  fn: ResolutionCtrl
};
